import { useEffect, useState } from 'react';
import moment from 'moment';

const getGranularityByPeriod = ({ period, granularityTypes }) => {
  const { before, after } = period;
  const diff = moment(before).diff(moment(after), 'days') + 1;
  return diff > 90 ? granularityTypes.MONTHLY : granularityTypes.WEEKLY;
};

const useAutoGranularity = ({ period, granularityTypes = {} }) => {
  if (!granularityTypes?.MONTHLY || !granularityTypes?.WEEKLY)
    throw new Error('useGranularity() - granularityTypes object is invalid');

  const [granularity, setGranularity] = useState(
    getGranularityByPeriod({ period, granularityTypes })
  );

  useEffect(() => {
    setGranularity(getGranularityByPeriod({ period, granularityTypes }));
  }, [period, granularityTypes]);

  return [granularity, setGranularity];
};

export default useAutoGranularity;
